import { useState } from "react";
import { Mail, ArrowRight, Check, Loader2, AlertCircle } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export function WaitlistBanner() {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email.trim() || isLoading) return;

    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch('/api/save-waitlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email.trim(),
          source: 'header_banner'
        })
      });

      const result = await response.json();

      if (response.ok) {
        setIsSubmitted(true);
        setEmail("");
        
        // Auto-hide success message după 5 secunde
        setTimeout(() => {
          setIsSubmitted(false);
        }, 5000);
      } else {
        setError(result.error || 'A apărut o eroare. Te rugăm să încerci din nou.');
      }
    } catch (err) {
      console.error('Waitlist submission error:', err);
      setError('Eroare de conexiune. Te rugăm să încerci din nou.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-primary/10 border-t border-primary/20 overflow-hidden">
      <div className="container mx-auto px-4 py-6">
        {isSubmitted ? (
          <div className="flex items-center justify-center gap-2 text-primary">
            <Check className="w-5 h-5 shrink-0" />
            <span className="font-medium text-sm sm:text-base">
              Te-ai înscris cu succes pe Waitlist!
            </span>
          </div>
        ) : (
          <form 
            onSubmit={handleSubmit} 
            className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3"
          >
            <div className="flex items-center gap-2 text-foreground text-center sm:text-left">
              <Mail className="w-5 h-5 text-primary shrink-0" />
              <span className="font-medium text-sm sm:text-base">
                Vrei raportul tău SEO gratuit?
              </span>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
              <Input
                type="email"
                placeholder="email@exemplu.ro"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError(null);
                }}
                className="w-full sm:w-64 h-11 bg-background"
                required
                disabled={isLoading}
              />
              <Button
                type="submit"
                size="default"
                className="w-full sm:w-auto h-11 whitespace-nowrap min-w-[180px]"
                disabled={!email.trim() || isLoading}
              >
                {isLoading ? (
                  <>
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                    <span className="hidden sm:inline">Se trimite...</span>
                    <span className="sm:hidden">Se trimite...</span>
                  </>
                ) : (
                  <>
                    <span className="hidden sm:inline">Înscrie-te pe Waitlist</span>
                    <span className="sm:hidden">Înscrie-te</span>
                    <ArrowRight className="w-4 h-4 ml-1" />
                  </>
                )}
              </Button>
            </div>
            
            {error && (
              <div className="flex items-center gap-2 text-red-500 text-sm w-full sm:w-auto">
                <AlertCircle className="w-4 h-4 shrink-0" />
                <span>{error}</span>
              </div>
            )}
          </form>
        )}
      </div>
    </div>
  );
}
